export const DISPUTES_LIST_MIN_SIZE = 100;
export const DISPUTES_TXN_MIN_SIZE = 5;
